import React from "react";
import ErrorModal from "./errorModal";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <ErrorModal
          title="Unexpected Error"
          description="Sorry, an unexpected error has occurred, please reload the website and try again."
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
